<template>
    <div class="filter-form box first-box v-sticky-top" :class="{ 'initial-popup p-3 p-lg-5 bg-white text-center position-absolute shadow-lg': initialPopup && !loading.status, 'no-popup-form': !initialPopup }">

        <div v-if="inputOnly">
            <div class="d-flex align-items-center justify-content-center">
                <div class="a-input-form-wrapper icon-right w-100">
                    <div class="wrapper w-100 position-relative">
                        <label class="w-100 position-relative ">
                            <gmap-autocomplete
                                ref="gmapAutocomplete"
                                @place_changed="setPlace"
                                placeholder=" "
                                id="gmap-autocomplete"
                                v-model="formattedAdress"
                                class="font-light w-100"
                                :options="autocompleteOptions"
                                :selectFirstOnEnter="true">
                            </gmap-autocomplete>

                            <div class="icon-wrapper pointer border-radius-main no-overflow bg-secondary text-white border-radius-main right-icon icon-square">
                                <svg class="icon-base">
                                    <use xlink:href="/dist/icons/solid.svg#search"></use>
                                </svg>
                            </div>

                            <span class="input-placeholder position-absolute no-events"> {{ placeholder }} </span>
                        </label>
                    </div>
                </div>

                <div class="button btn btn-primary btn-small icon-square ms-2" v-if="!loading.status" @click.stop.prevent="locatorButtonPressed">
                    <div :class="{ 'me-2': initialPopup && !loading.status, 'me-0': !initialPopup }" class="icon-wrapper pointer border-radius-main">
                        <svg class="icon-base">
                            <use xlink:href="/dist/icons/solid.svg#location"></use>
                        </svg>
                    </div>
                    <!-- <font-awesome-icon style="font-size: 0.7rem" :class="{ 'me-2': initialPopup && !loading.status, 'me-0': !initialPopup }" icon="location" /> -->

                    <h2 class="title initial-popup-content text-left mb-3 h3">{{ text.appointment }}</h2>

                    <span class="initial-popup-content"> {{ text.search_functionDrupalDesktop }}</span>
                </div>
            </div>

            <div class="result-summary text-s text-center text-gray-d mt-2 px-3" v-if="place && radius ">
                <span v-if="place && place.formatted_address && storesVisibleCount>0">{{ storesVisibleCount }} {{ text.area }} {{ radius }} km</span>
                <span v-if="place && place.formatted_address && storesVisibleCount>0">
                {{ text.around }} {{ place.formatted_address  ? place.formatted_address : text.germany }}
            </span>
                <div v-if="storesVisibleCount === 0" class="no-result-found">
                    <span class="mb-2">{{ text.noResultMessage }} {{ radius }} km {{ text.found }}</span>
                    <span v-if="radius==50">{{ text.extendSearch }}</span>
                    <span v-if="radius>50">{{ text.extendFailed }}</span>
                </div>
            </div>
            <div class="button btn btn-outline-primary btn-search-more" v-if="storesVisibleCount == 0 && radius==50 && place && radius" @click="setRadius">
                {{ text.search_more }}
            </div>
        </div>

        <div v-else>
            <div @click="removePopup" class="close-popup pointer position-absolute initial-popup-content">
                <font-awesome-icon class="me-2" icon="times"/>
            </div>

            <h2 class="title initial-popup-content text-left mb-3 h3">{{ text.appointment }}</h2>
            <p class="description text-left mb-4 initial-popup-content p">
                <span class="desktop-area">{{ text.search_functionDrupalDesktop }}</span>
                <span class="mobile-area">{{ text.search_functionDrupalMobile}}</span>
            </p>

            <div class="locate-map-ic position-absolute ms-3 me-2 initial-popup-content">
                <font-awesome-icon icon="map-marker-alt"/>
            </div>

            <div class="btn search-button btn btn-secondary icon-circle icon-square position-absolute" v-if="!loading.status">
                <font-awesome-icon style="color: #fff" icon="search"/>
            </div>

            <div class="a-input-form-wrapper icon-right icon-left">
                <div class="wrapper w-100 position-relative">
                    <label class="w-100 position-relative ">
                        <div class="icon-wrapper border-radius-main no-overflow left-icon">
                            <svg class="icon-base">
                                <use xlink:href="/dist/icons/solid.svg#map-pin"></use>
                            </svg>
                        </div>

                        <gmap-autocomplete
                            ref="gmapAutocomplete"
                            @place_changed="setPlace"
                            placeholder=" "
                            id="gmap-autocomplete"
                            v-model="formattedAdress"
                            class="font-light w-100"
                            :options="autocompleteOptions"
                            :selectFirstOnEnter="true">
                        </gmap-autocomplete>

                        <div class="icon-wrapper pointer border-radius-main no-overflow bg-secondary text-white border-radius-main right-icon icon-square">
                            <svg class="icon-base">
                                <use xlink:href="/dist/icons/solid.svg#search"></use>
                            </svg>
                        </div>

                        <span class="input-placeholder position-absolute no-events"> {{ placeholder }} </span>
                    </label>
                </div>
            </div>

            <span class="my-4 initial-popup-content">{{ text.or }}</span>

            <div class="btn btn-primary d-flex align-items-center justify-content-center icon-left" v-if="!loading.status" @click.stop.prevent="locatorButtonPressed">
            <span class="d-flex align-items-center justify-content-center">
                <div class="icon-wrapper border-radius-main no-overflow ">
                    <svg class="icon-base">
                        <use xlink:href="/dist/icons/solid.svg#location"></use>
                    </svg>
                </div>

                <span class="initial-popup-content desktop-area"> {{ text.searchAreaDesktop }} </span>
                <span class="initial-popup-content mobile-area"> {{ text.searchAreaMobile }} </span>
            </span>
            </div>

            <div class="result-summary text-s text-center text-gray-d px-4 mt-2" v-if="place && radius">
                <span v-if="place && place.formatted_address && storesVisibleCount>0">{{ storesVisibleCount }} {{ text.area }} {{ radius }} km</span>
                <span v-if="place && place.formatted_address && storesVisibleCount>0">
                {{ text.around }} {{ place.formatted_address  ? place.formatted_address : text.germany }}
            </span>
                <div v-if="storesVisibleCount === 0" class="no-result-found">
                    <span class="mb-2">{{ text.noResultMessage }} {{ radius }} km {{ text.found }}</span>
                    <span v-if="radius==50">{{ text.extendSearch }}</span>
                    <span v-if="radius>50">{{ text.extendFailed }}</span>
                </div>
            </div>
            <div class="button btn btn-outline-primary btn-search-more" v-if="storesVisibleCount == 0 && radius==50 && place && radius" @click="setRadius">{{ text.search_more }}</div>
            <Spinner :message ="loading.message" v-if="loading.status && !initialPopup && !proceed"  class="mt-4" />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import Spinner from 'vue-simple-spinner'
import ServiceDrupal from '@/services/ServiceDrupal.js'

export default {
    name: 'FilterForm',
    props: ['inputOnly'],
    components: {
        Spinner
    },
    data () {
        return {
            placeholder: Drupal.t('PLZ oder Ort eingeben') + '...',
            updatedRadius: 50,
            updatedPlace: null,
            autocompleteOptions: {
                componentRestrictions: {
                    country: ['de']
                },
                fields: ['name', 'geometry.location', 'place_id', 'formatted_address']
            },
            text: {
                appointment: Drupal.t('Find a store & book an appointment'),
                search_functionDrupalDesktop: Drupal.t('With our search function you can find the nearest Optiker Bode store quickly and easily. Our optician will advise you in detail and competently on everything to do with glasses, sunglasses and contact lenses. We look forward to you!'),
                search_functionDrupalMobile: Drupal.t('With our search function you can find the nearest Optiker Bode branch quickly and easily.'),
                around: Drupal.t('around'),
                germany: Drupal.t('Germany'),
                area: Drupal.t('Stores in the area of'),
                searchAreaDesktop: Drupal.t('Mein Standort'),
                searchAreaMobile: Drupal.t('Mein Standort'),
                extendSearch: Drupal.t('Would you like to increase the search radius?'),
                extendFailed: Drupal.t('Unfortunately there is no Optiker Bode branch in the area you selected'),
                noResultMessage: Drupal.t('No Optiker Bode branch within a radius of'),
                found: Drupal.t('found'),
                search_more: Drupal.t('Search more'),
                or: Drupal.t('or'),
                locDenied: Drupal.t('User Denied geolocation.')
            }
        }
    },
    computed: {
        google: gmapApi,
        ...mapGetters('store', ['storesVisibleCount']),
        ...mapState([
            'selectedStore',
            'initialPopup',
            'proceed',
            'loading'
        ]),
        formattedAdress () {
            return this.place ? this.place.formatted_address : ''
        },
        ...mapState({
            place: state => state.map.place,
            radius: state => state.map.radius,
            center: state => state.map.center
        })
    },
    methods: {
        removePopup () {
            this.$store.dispatch('removeIntitalPopup', {})
        },
        setPlace (place) {
            this.updatedRadius = 50
            this.updatedPlace = place
            this.updateLocation()

            // Google Tag-Manager push 'search for a store' to dataLayer
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: `store_search`,
                    event_type: `search_string`,
                    event_data: {
                        search_string: place.formatted_address
                    }
                })
            }
        },
        setRadius () {
            this.updatedRadius = 200
            this.updateLocation()
        },
        locatorButtonPressed () {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.$refs.gmapAutocomplete.$refs.input.placeholder = Drupal.t('My location')
                    const place = {
                        geometry: {
                            locationFromNavigator: {
                                lat: position.coords.latitude, lng: position.coords.longitude
                            }
                        }
                    }
                    this.updatedRadius = 50
                    this.updatedPlace = place
                    this.updateLocation()
                },
                error => {
                    const notification = {
                        type: 'error',
                        message: Drupal.t('User Denied geolocation.'),
                        localisation: true
                    }
                    this.$store.dispatch('stopLoading', null, { root: true })
                    this.$store.dispatch('notification/add', notification, { root: true })
                }
            )

            // Google Tag-Manager push 'search in area for store' to dataLayer
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: `store_search`,
                    event_type: `search_area`,
                    event_data: {}
                })
            }
        },
        updateLocation () {
            const place = this.updatedPlace ? this.updatedPlace : this.place
            this.$store.dispatch('startLoading', { message: Drupal.t('Searching for place ...') })
            this.$store.commit('map/SET_LIVE_SEARCH', false)
            this.$store.dispatch('setStore', null)
            this.$store.dispatch('map/updateRadius', this.updatedRadius)
            this.$store.dispatch('map/updatePlace', place)
            this.$store.dispatch('store/update', {
                google: this.google,
                radius: this.radius,
                place: place,
                center: this.center,
                live: false
            })
            this.$store.commit('map/SET_LIVE_SEARCH', false)
            this.$store.dispatch('removeIntitalPopup', {})
        }
    }
}
</script>
